import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {catchError, concatMap, map} from 'rxjs/operators';
import {of} from 'rxjs';

import {loadAllInstanceTypes, loadAllInstanceTypesFailure, loadAllInstanceTypesSuccess} from '../actions/all-instance-types.actions';
import {ClusterInstanceTypesVocabularyService} from '../../../services/api/vocabulary/cluster/instance-types/cluster.instance-types.vocabulary.service';
import {ClusterInstanceTypeRecord} from '../../../services/api/vocabulary/cluster/instance-types/cluster.instance-type.vocabulary.model';


@Injectable()
export class AllInstanceTypesEffects {

  // noinspection JSUnusedGlobalSymbols
  loadAllInstanceTypes$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(loadAllInstanceTypes),
      concatMap(() =>
        this.service.getAll()
          .pipe(
            map((data: ClusterInstanceTypeRecord[]) => loadAllInstanceTypesSuccess({data})),
            catchError((error: unknown) => of(loadAllInstanceTypesFailure({error})))
          )
      )
    );
  });


  constructor(
    private readonly actions$: Actions,
    private readonly service: ClusterInstanceTypesVocabularyService
  ) {
  }

}
